<template>
  <div class="message-container">
    <img src="@/assets/icons/invalid.png" style="max-width:20%;margin-bottom:2rem"/>
    <div class="p-error">{{message}}</div>
  </div>
</template>

<script>

export default {
  name: 'MessageControl',
  inject: ['dialogRef'],
  components: {
    
  },
  data(){
    return {
      
    }
  },
  props: {
  },
  methods:{
    
  },
  created(){

    if(this.$common.version==this.$common.E88)
    {

      //const msg=this.$t('message.form_unavailable_h5');

      this.message=this.i18n.t('message.welcome_to_88E');

    }
    else
    {

      this.message=this.i18n.t('message.welcome_to_top_qr');

    }
    

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.message-container{
  height:100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding:1rem;
}

</style>